module.exports = __webpack_public_path__ + "static/media/delnum.ebb99ca4.svg";